import type Button from "../../../src/models/Button";
import { ChannelType, channelTypeHirarchie } from "../../../src/models/ChannelType";
import type { GlassButtonFunction, GlassButtonOptions, GlassButtonRow } from "./buttonModels/ButtonModelParameters";
import { getButtonProduct3DMapping } from "./buttonProductMapping";

export interface Button3DViewContext { page?: number; press?: number }

/** Adapter from the main application's Button to the product-independent display control. */
export function getButton3DViewData(button: Button, { page = 0, press = 0 }: Button3DViewContext = {}) {
  const properties = button.baseProps.buttonBaseProps;
  const rowCount = properties?.numberOfButtonRows ?? 1;
  const rows: GlassButtonRow[] = [];
  const displayFunction = (row: number, side: number): GlassButtonFunction => {
    const base = button.getButtonChannel(row, side);
    const channel = press ? button.buttonChannels.getItemByTag((base?.tag ?? "") + (press === 1 ? "_l" : "_xl")) : base;
    const type = channel?.channelType ?? ChannelType.Unknown;
    const symbol = channelTypeHirarchie("isRollo")?.includes(type) ? "blind"
      : channelTypeHirarchie("isHeating")?.includes(type) || type === ChannelType.OperationMode ? "heating"
      : channelTypeHirarchie("isLight")?.includes(type) ? "light"
      : type === ChannelType.Scene ? "scene" : "power";
    return { label: (properties?.hasDisplay ? channel?.name : channel?.nameOrConnectedNames) ?? "", symbol };
  };
  for (let index = 0; index < rowCount; index++) {
    const row = index + page * rowCount;
    rows.push(button.isButtonRowSplit(row)
      ? { mode: "split", left: displayFunction(row, 0), right: displayFunction(row, 1) }
      : { mode: "shared", shared: displayFunction(row, 0) });
  }
  const mapping = getButtonProduct3DMapping(button);
  const parameters: GlassButtonOptions = {
    widthMm: properties?.widthMm, heightMm: properties?.heightMm,
    color: properties?.color === "black" ? "black" : "white",
    hasDisplay: properties?.hasDisplay, horizontal: properties?.horizontal, rows,
    ...mapping.parameters,
  };
  return { model: mapping.model, parameters };
}
